<template>
    <div class="apple-sso-button-wrap">
        <button @click="handleSignIn" class="apple-sso-button">
            <font-awesome-icon icon="fa-brands fa-apple" />
            <span>{{$gettext('Sign in with Apple')}}</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    name: "AppleSSOButton",
    props: {
        businesslocation: {
            type: String,
            default: null
        },
        preferredlanguage: {
            type: String,
            default: 'en'
        }
    },
    mounted() {
        if (this.appleClientId) {
            this.setupData()
        }
    },
    computed: {
        ...mapGetters({
            getAppleCallbackData: "auth/getAppleCallbackData",
            isAuthenticated: "auth/getAuthenticated"
        }),
        appleClientId () {
            return process.env.VUE_APP_APPLE_CLIENT_ID
        }
    },
    methods: {
        ...mapActions({ 
            processAppleCredentials: "auth/processAppleCredentials"
        }),
        setupData() {
            if (!window.AppleID) {
                const script = document.createElement('script')
                script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
                script.async = true
                script.onload = () => this.onAppleScriptLoaded()
                document.head.appendChild(script)
            } else {
                this.onAppleScriptLoaded()
            }
        },
        onAppleScriptLoaded() {
            if (!this.isAuthenticated) {
                window.AppleID.auth.init({
                    clientId : this.appleClientId,
                    scope : 'name email',
                    redirectURI : `${window.location.origin}/en/accounts/api/third_party_credentials/`,
                    usePopup : true
                })
            }
        },
        handleSignIn() {
            window.AppleID.auth.signIn().then(response => {
                this.appleSSOCallback(response)
            }).catch(error => {
                console.error('Sign-In Error:', error)
            })
        },
        appleSSOCallback (data) {
            const callbackData = data
            callbackData.country = this.businesslocation
            callbackData.preferred_language = this.preferredlanguage

            this.processAppleCredentials(callbackData).then(() => {
                this.$emit('authenticatedWithApple', true)
            }).catch((error) => {
                if (error.status === 428) {
                    this.$emit('country-not-set', false)
                }
            })
        }
    }
}
</script>

<style lang="scss">
.apple-sso-button-wrap {
  width: 100%;
  text-align: center;
  .apple-sso-button {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    height: 38px !important;
    border: 1px solid #dfdfdf;
    border-radius: 19px; /* height / 2 */
    background-color: #ffffff;
    font-size: 16px;
    transition: background-color .218s,border-color .218s;

    @media (max-width: 576px) {
        width: 250px !important;
    }
  }
}

.apple-sso-button:hover {
    border: 1px solid #D2E3FC;
    background-color: #F9FBFE;
}
</style>